import React from "react";
import Checkbox from "@material-ui/core/Checkbox";

const BooleanFilter = ({ columnDef, onFilterChanged }) => (
	<Checkbox
		indeterminate={columnDef.filterValue === undefined}
		checked={columnDef.filterValue === "checked"}
		onChange={() => {
			let val;
			if (columnDef.filterValue === undefined) {
				val = "checked";
			} else if (columnDef.filterValue === "checked") {
				val = "unchecked";
			}

			onFilterChanged(columnDef.tableData.id, val);
		}}
	/>
);

export default BooleanFilter;
